<template>
    <div :class="['page account',{ off: !pageOn }]">
        <VHeader @back="back" />
        <div class="page-content rating">
            <h2 style="text-align: center;margin: 20px;font-weight: 400;">Current Campaigns</h2>
            <p class="btn" v-for="campaign in clientCampaigns" @click="(campaign_id = campaign._id,pushPage('client-campaign'))">{{ campaign.title }}</p>
        </div>
        <Auth v-if="pages.indexOf('auth') > -1" @success="popPage('auth')" />
        <Campaign v-if="pages.indexOf('client-campaign') > -1" @exit="popPage('client-campaign')" :campaign_id="campaign_id" />
        <MyAccount v-if="pages.indexOf('my-account') > -1" @exit="popPage('my-account')" />        
    </div>
    
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'

import Auth from '@/components/Auth.vue'
import Campaign from '@/components/Campaign.vue'
import MyAccount from '@/components/myAccount.vue'

export default {
    name: 'account',
    components: {
        VHeader,
        Auth,
        Campaign,
        MyAccount
    },
    mixins: [ pageOn ],
    computed: {
        auth () { return this.$store.state.auth },
        pages () { return this.$store.state.pages },
        clientCampaigns () { return this.$store.state.clientCampaigns }
    },
    data () {
        return {
            campaign_id: '',
            showAccount: false
        }
    },
    mounted () {
        if ( !this.auth ) this.pushPage('auth');
    },
    methods: {
            avatar () {
                console.log('avatar parent');
                this.pushPage('my-account');
            },
        ...mapMutations(['pushPage','popPage'])
    }
}

</script>

<style>

</style>